var ElementsType = (function () {
    function ElementsType() {
    }
    return ElementsType;
}());
export { ElementsType };
/**
 *
 */
ElementsType.TRIANGLE = "triangle";
/**
 *
 */
ElementsType.LINE = "line";



// WEBPACK FOOTER //
// ../dist/lib/elements/ElementsType.js